import script from "./Render3D.vue?vue&type=script&setup=true&lang=js"
export * from "./Render3D.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__